/** Narrow-scope demo-anchor for the hurricane subsystem only.
 * Bills, payments, outages, greetings keep wall-clock via useNow(). */
import { useNow } from "./use-now";

export function useHurricaneAnchor(envOverride?: string): Date {
  const now = useNow();
  if (envOverride) {
    const parsed = new Date(envOverride);
    if (!isNaN(parsed.getTime())) return parsed;
  }
  return now;
}
